import React from "react";
import './PlayerIcon.css'
import {getPlayerHexColor} from "../../../utils/players/getPlayerHexColor";
import {addClassNameIfTrue} from "../../../utils/other/addClassNameIfTrue";

export function PlayerIcon({playerColor, color, isSmall, className}) {
  const backgroundColor = color || (playerColor ? getPlayerHexColor(playerColor) : 'white');
  return <div
    className={`player-icon ${addClassNameIfTrue(isSmall, 'player-icon-small')} ${className || ''}`}
    style={{
      backgroundColor,
    }}
  />;
}
